import { render } from "./FeaturedReleases.vue?vue&type=template&id=f7b6b8ea"
import script from "./FeaturedReleases.vue?vue&type=script&lang=js"
export * from "./FeaturedReleases.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__